
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../Components/Header";
import Modal from "../../Components/Modal";
import Client from "../Client";
import Home from "../../Pages/Home";
import Timeline from "../../Pages/Timeline";
import Explore from "../../Pages/Explore";
import Settings from "../../Pages/Settings";
import Login from "../../Pages/Login";
import Register from "../../Pages/Register";
import NotFound from "../../Pages/NotFound";
import { createStructuredSelector } from "reselect";
import { selectIsLoading, selectPopUp } from "./selector";
import { connect } from "react-redux";
import Loader from "../../Components/Loader";
import NftCollection from "../../Pages/NftCollection";
import Confirmation from "../../Pages/Confirmation";


function App({popup, isLoading, skipLoader}) { 
  
  return (
    <div className="App">
        <BrowserRouter>
        <ToastContainer />
        {isLoading? (<Loader />): ''}
        <Routes>
          <Route path='/:username' element={<Client children={<Home />} />}/>
          <Route path='/' element={<Client children={<Home />} />}/>
          <Route path='/collection' element={<Client children={<NftCollection />} />}/>
          <Route path='/collection/:username' element={<Client children={<NftCollection />} />}/>
          <Route path='/timeline' element={<Client children={<Timeline />} />}/>
          <Route path='/explore' element={<Client children={<Explore />} />}/>
          <Route path='/settings/:mode' element={<Client children={<Settings />} />}/>
          <Route path='/login' element={<Header children={<Login />} />}/>
          <Route path='/confirmation/:confirmCode' element={<Header children={<Confirmation />} />}/>
          <Route path='/register' element={<Header children={<Register />} />}/>
          <Route path='*' element={<Header children={<NotFound />} />}/>
        </Routes>
        <Modal isOpen={popup.isOpen} onClose={popup.onClose} content={popup.content} />
    </BrowserRouter>
      </div>
  );
}

const mapStateToProps = createStructuredSelector({
    popup: selectPopUp,
    isLoading: selectIsLoading
});

export default connect(mapStateToProps)(App);
